var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    _vm._g(
      {
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "32",
          height: "32",
          fill: "none"
        }
      },
      _vm.$listeners
    ),
    [
      _c("path", {
        attrs: {
          fill: "#ffe252",
          d:
            "M0 4a4 4 0 0 1 4-4h24a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#4868fd",
          d:
            "M13.942 7.177c0 .914 1.143 3.337 1.783 4.617.183.32.64.32.777 0 .64-1.28 1.783-3.749 1.783-4.617 0-1.189-.96-2.194-2.194-2.194-1.189 0-2.149 1.006-2.149 2.194zm1.783 13.76c-.64 1.28-1.783 3.703-1.783 4.617a2.195 2.195 0 0 0 4.388 0c0-.914-1.143-3.337-1.783-4.617-.183-.366-.686-.366-.823 0zm9.555-6.766c-.914 0-3.337 1.143-4.617 1.783-.32.183-.32.64 0 .777 1.28.64 3.703 1.783 4.617 1.783 1.189 0 2.194-.96 2.194-2.194s-.96-2.149-2.194-2.149zm-13.715 1.783c-1.28-.64-3.703-1.783-4.617-1.783-1.189 0-2.194.96-2.194 2.194s.96 2.194 2.194 2.194c.914 0 3.337-1.143 4.617-1.783a.473.473 0 0 0 0-.823zM8.092 8.32a2.18 2.18 0 0 0 0 3.109c.64.64 3.2 1.554 4.526 2.011.366.137.686-.229.549-.549-.457-1.326-1.371-3.886-2.011-4.526a2.09 2.09 0 0 0-3.063-.046zm11.519 10.971c-.366-.137-.686.229-.549.549.457 1.326 1.371 3.886 2.011 4.526a2.18 2.18 0 0 0 3.109 0 2.18 2.18 0 0 0 0-3.108c-.686-.594-3.2-1.509-4.571-1.966zm.001-5.897c1.326-.457 3.886-1.371 4.526-2.011a2.18 2.18 0 0 0 0-3.109 2.18 2.18 0 0 0-3.109 0c-.64.64-1.554 3.2-2.011 4.526-.091.412.274.732.594.594zm-6.994 5.897c-1.326.457-3.886 1.371-4.526 2.011a2.18 2.18 0 0 0 0 3.109 2.18 2.18 0 0 0 3.109 0c.64-.64 1.554-3.2 2.011-4.526a.485.485 0 0 0-.594-.594zm3.52-.457a2.47 2.47 0 0 0 2.469-2.469 2.47 2.47 0 0 0-2.469-2.469 2.47 2.47 0 0 0-2.469 2.469 2.47 2.47 0 0 0 2.469 2.469z"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }